import { useMemo } from 'react'
import { getHeyImmoExperimentState } from '../../../utils/features/heyImmoExperiment'

export function useHeyImmoExperimentTracking(isHeyImmoSupported: boolean) {
  return useMemo(() => getHeyImmoExperimentState({ isHeyImmoSupported }).trackingParameters, [isHeyImmoSupported])
}
